// assets
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';

// ==============================|| MENU ITEMS - CLAIMS ||============================== //

const claims = {
  id: 'claims',
  title: 'Claims',
  type: 'collapse',
  url: '/claims',
  icon: FileTextOutlined,
  permission: {
    module: 'claims',
    level: 10
  },
  children: [
    {
      id: 'claims-payment-schedule',
      title: 'Payment Schedules',
      type: 'item',
      url: '/claims/payment-schedule',
      icon: CalendarOutlined,
      permission: {
        module: 'claims',
        level: 10
      }
    }
  ]
};

export default claims;
